<template>
  <div>
    <d-card>
      <d-card-row>
        <v-popup-form
          v-if="property"
          :first-status="true"
          :property="property"
          close-label="previous"
          @success="success"
          @status="updateNewStatus"
          @close="cancelCreatePropertyStatus"
        />
      </d-card-row>
    </d-card>
  </div>
</template>

<script>
import form_popup from "./_form_popup.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("new_property")
    };
  },
  components: {
    "v-popup-form": form_popup
  },
  data() {
    return {
      property: null
    };
  },
  created() {
    this.getProperty();
  },

  methods: {
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
    success(event) {
      this.$router.push({
        name: "properties.show.statuses",
        params: { property: event.data.propertyStatus.property_id }
      });
    },
    cancelCreatePropertyStatus() {
      this.$router.push({
        name: "properties.create.pictures",
        params: { property: this.property.id }
      });
    },
    getProperty() {
      this.$http
        .get(
          this.$laravel.route("api.properties.show", {
            property: this.$route.params.property
          })
        )
        .then(response => {
          this.loading = false;
          this.property = response.data.data;
        })
        .catch(e => {
          console.error(e);
        });
    },
    updateNewStatus(event) {}
  }
};
</script>
